import React from "react";
import { Link } from "react-router-dom";
import "../../styles/Error5000.css"; // Import d'un fichier CSS spécifique
import { useTranslation } from 'react-i18next';  
import "../../../i18n";
const Error500 = () => {
  const { t, i18n } = useTranslation(); 
  return (
    <div className="error-500">
      <h1>500</h1>
      <p>
       {t("500ermess")}
      </p>
      <Link to="/" className="back-home">
         {t('home_button')}
      </Link>
    </div>
  );
};

export default Error500;
